// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as API$LumiAuthentication from "./API.res.js";
import * as Form$LumiAuthentication from "./Form.res.js";
import * as I18n$LumiAuthentication from "./I18n.res.js";
import * as Modal$LumiAuthentication from "./Modal.res.js";
import * as Validate$LumiAuthentication from "./Validate.res.js";

function passwordResetLockFromUrl(url) {
  let match = url.hash;
  if (match !== "change-password") {
    return;
  }
  let params = new URLSearchParams(url.search);
  return LumiOption.sequence2(V2$Linear.map([
    "accountId",
    "secret"
  ], paramName => Primitive_option.fromNull(params.get(paramName))));
}

function replacePasswordResetLockInUrl() {
  let url = URL.parse(window.location.href);
  url.hash = "";
  url.searchParams.delete("accountId");
  url.searchParams.delete("secret");
  window.location.replace(url.href);
}

function PasswordReset$ChooseNewPassword(props) {
  let dispatch = props.dispatch;
  let verifyPasswordTxt = props.verifyPasswordTxt;
  let newPasswordTxt = props.newPasswordTxt;
  let newPasswordValid = Validate$LumiAuthentication.newPassword(newPasswordTxt);
  let verifyPasswordValid = verifyPasswordTxt === newPasswordTxt;
  let valid = newPasswordValid && verifyPasswordValid;
  return JsxRuntime.jsxs(Modal$LumiAuthentication.Form.make, {
    title: "PhraseChangePassword",
    onSubmit: param => dispatch("ConfirmChooseNewPassword"),
    children: [
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx(Form$LumiAuthentication.$$Error.make, {
            error: props.lastError
          }),
          JsxRuntime.jsx("p", {
            children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
              entry: "PhraseEnterNewPassword"
            })
          }),
          JsxRuntime.jsx(Form$LumiAuthentication.NewPasswordField.make, {
            value: newPasswordTxt,
            valid: newPasswordValid,
            onChange: pass => dispatch({
              TAG: "UpdatePasswordTxt",
              _0: pass
            })
          }),
          JsxRuntime.jsx(Form$LumiAuthentication.VerifyPasswordField.make, {
            value: verifyPasswordTxt,
            valid: verifyPasswordValid,
            onChange: pass => dispatch({
              TAG: "UpdateVerifyPasswordTxt",
              _0: pass
            })
          })
        ],
        className: "modal-card-body"
      }),
      JsxRuntime.jsx("footer", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                  entry: {
                    TAG: "CommonEntry",
                    _0: "Close"
                  }
                }),
                className: "button",
                type: "button",
                onClick: param => dispatch("BackToLogin")
              }),
              className: "control"
            }),
            JsxRuntime.jsx("p", {
              children: JsxRuntime.jsx(Form$LumiAuthentication.Submit.make, {
                classList: [
                  [
                    "button",
                    true
                  ],
                  [
                    "is-success",
                    true
                  ]
                ],
                enabled: valid,
                label: "PhraseChangePassword"
              }),
              className: "control"
            })
          ],
          className: "field is-grouped is-grouped-right is-flex-1"
        }),
        className: "modal-card-foot"
      })
    ]
  });
}

let ChooseNewPassword = {
  make: PasswordReset$ChooseNewPassword
};

function PasswordReset$PasswordChanged(props) {
  let dispatch = props.dispatch;
  return JsxRuntime.jsxs(Modal$LumiAuthentication.make, {
    title: "PhraseChangePassword",
    children: [
      JsxRuntime.jsx("section", {
        children: JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
            entry: "PhrasePasswordChanged"
          })
        }),
        className: "modal-card-body"
      }),
      JsxRuntime.jsx("footer", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("p", {
            children: JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                entry: "PhraseToLogin"
              }),
              className: "button is-success",
              type: "button",
              onClick: param => dispatch("BackToLogin")
            }),
            className: "control"
          }),
          className: "field is-grouped is-grouped-right is-flex-1"
        }),
        className: "modal-card-foot"
      })
    ]
  });
}

let PasswordChanged = {
  make: PasswordReset$PasswordChanged
};

function PasswordReset(props) {
  let toParent = props.toParent;
  let secret = props.secret;
  let accountId = props.accountId;
  let match = LumiReactReducer.useReducer(() => ({
    TAG: "Init",
    _0: {
      lastError: undefined,
      newPasswordTxt: "",
      verifyPasswordTxt: "",
      succeeded: false
    }
  }), undefined, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "ConfirmChooseNewPassword" :
          return {
            TAG: "Effect",
            _0: param => {
              let dispatch = param.dispatch;
              return LumiRequest.resultFutureEffect(API$LumiAuthentication.resetPasswordConfirm(accountId, secret, param.state.newPasswordTxt), () => dispatch("ChooseNewPasswordSucceeded"), err => dispatch({
                TAG: "ChooseNewPasswordFailed",
                _0: err
              }));
            }
          };
        case "ChooseNewPasswordSucceeded" :
          return {
            TAG: "UpdateWithEffect",
            _0: {
              lastError: state.lastError,
              newPasswordTxt: state.newPasswordTxt,
              verifyPasswordTxt: state.verifyPasswordTxt,
              succeeded: true
            },
            _1: param => {
              replacePasswordResetLockInUrl();
            }
          };
        case "BackToLogin" :
          return {
            TAG: "Effect",
            _0: param => {
              toParent({
                TAG: "ShowPasswordLogin",
                initialEmail: "",
                initialError: undefined
              });
            }
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdatePasswordTxt" :
          return {
            TAG: "Update",
            _0: {
              lastError: state.lastError,
              newPasswordTxt: action._0,
              verifyPasswordTxt: state.verifyPasswordTxt,
              succeeded: state.succeeded
            }
          };
        case "UpdateVerifyPasswordTxt" :
          return {
            TAG: "Update",
            _0: {
              lastError: state.lastError,
              newPasswordTxt: state.newPasswordTxt,
              verifyPasswordTxt: action._0,
              succeeded: state.succeeded
            }
          };
        case "ChooseNewPasswordFailed" :
          let err = action._0;
          console.error("resetPasswordConfirm failed", err);
          if (typeof err === "object" && err.TAG === "ServerError" && err.status === 401) {
            return {
              TAG: "UpdateWithEffect",
              _0: {
                lastError: "PhraseWaitingTimeExpired",
                newPasswordTxt: state.newPasswordTxt,
                verifyPasswordTxt: state.verifyPasswordTxt,
                succeeded: state.succeeded
              },
              _1: param => {
                toParent({
                  TAG: "ShowPasswordForgotten",
                  initialEmail: "",
                  initialError: "PhraseWaitingTimeExpired"
                });
              }
            };
          }
          return {
            TAG: "Update",
            _0: {
              lastError: I18n$LumiAuthentication.entryFromApiError(err),
              newPasswordTxt: state.newPasswordTxt,
              verifyPasswordTxt: state.verifyPasswordTxt,
              succeeded: state.succeeded
            }
          };
      }
    }
  });
  let dispatch = match[1];
  let match$1 = match[0];
  if (match$1.succeeded) {
    return JsxRuntime.jsx(PasswordReset$PasswordChanged, {
      dispatch: dispatch
    });
  } else {
    return JsxRuntime.jsx(PasswordReset$ChooseNewPassword, {
      lastError: match$1.lastError,
      newPasswordTxt: match$1.newPasswordTxt,
      verifyPasswordTxt: match$1.verifyPasswordTxt,
      dispatch: dispatch
    });
  }
}

let T;

let make = PasswordReset;

export {
  T,
  passwordResetLockFromUrl,
  replacePasswordResetLockInUrl,
  ChooseNewPassword,
  PasswordChanged,
  make,
}
/* LumiRequest Not a pure module */
